import noop from 'lib/function/noop'
import type { SupportedActionReward } from 'loyalty/constants/loyaltyActionRewards'
import * as React from 'react'

const EMPTY_PENDING_ACTION_NAMES: ReadonlySet<SupportedActionReward> = new Set()

interface LoyaltyActionRewardContextValue {
  startPolling: (actionName: SupportedActionReward) => void
  pendingActionNames: ReadonlySet<SupportedActionReward>
}

const LoyaltyActionRewardContext = React.createContext<LoyaltyActionRewardContextValue>({
  startPolling: noop,
  pendingActionNames: EMPTY_PENDING_ACTION_NAMES,
})

export default LoyaltyActionRewardContext
